






























/*
NON ZERO INPUT:
---------------

IT'S A NUMERIC ENTRY TEXT FIELD, THAT
WHEN IT STARTS, IF THE INITIAL VALUE IS ZERO, IT 
EMPTIES THE INPUT, SO YOU ARE FORCED TO SUPPLY 
A VALUE INSTEAD OF EMPTY (IF THERE IS A RULE TO ENFORCE IT).

AFTER YOU SUPPLY A VALUE, E.G. ZERO AGAIN, IT WILL STICK, 
BECAUSE IT'S NULLIFIED ONLY THE FIRST TIME AROUND.

WE DO THIS TO:
- FORCE USERS TO SUPPLY A VALUE ON DEFAULT FIELDS THAT START WITH A VALUE OF ZERO.
- DON'T FORCE IT AFTER A NEW VALUE HAS BEEN SET, EVEN IF IT'S ZERO.

- IF THE USER ENTERS ZERO AS HIS DESIRED VALUE, ON A REFRESH,
THE ZERO WILL BE REPLACED BY EMPTY PER THE FIRST RULE. 

SO THIS CONTROL IS GOOD AS LONG AS THE "ZERO" IS NOT USED
COMMONLY.

*/
import { PRICE_REQ_RULES2 } from "@/validators";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
// import axios from "axios";
// import * as CL from "../Mtc_classes";
// import { MtcADMIN } from "../Mtc";
// import AdminTemplate from "../../../dev/Components/AdminTemplate.vue";
// import AdminTitles from "../../../dev/Components/AdminTitles.vue";

@Component({
  components: {}
})
export default class NonZeroInput extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
	// mounted(){}
	// created(){}

	/* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  @Prop()
  public value: number;

	@Prop()
	public rules: any;

	@Prop({default:0})
	public min: number;

	@Prop({default:false})
	public outlined: boolean;

	@Prop()
	public disabled: boolean;

	@Prop()
	public label: string;

	@Prop()
	public prependInnerIcon: string;

  /* PRIVATE VARIABLES, __ POSTFIXED */
  private valueSet__: boolean=false;

  /* VUE DATA */
  public ourValue: number = null;


  /* VUE WATCH */
  @Watch("value", { immediate:true })
  onValueChanged(newVal: any, oldVal: any) {

		if (!this.valueSet__){
			/* THE FIRST TIME WE ENTER HERE.
			*/
			if (newVal==0)
				newVal = null;

				this.valueSet__ = true;
		}else{
			/* DON'T MAKE THIS FIXING ANY MORE, 
			OTHER THAN THE FIRST TIME AROUND ?
			*/
		}

		this.ourValue = newVal;
	}

  /* VUE COMPUTED METHODS */
  // get date(): Date {
  //   return new Date();
  // }

  /* PRIVATE METHODS */
  // private MyFunction():void{}

  /* VUE METHODS */
  public BlurNotify():void{
		// console.log("Blur Notify");
		this.$emit('change', this.ourValue);
	}

  public InputNotify():void{
		// console.log("Input Notify");
		this.$emit('input', this.ourValue);
	}

	// public OnChange(){
	// }
}
